<template lang="pug">
  validation-observer(ref='validation' tag='form')
    div.container
      div.form
        app-divider(
          label="Upload de cadastros realizados em campo",
        )
        div.radio-buttons
          el-radio-group.radio-group(
            @change="setGeomensorVistoriador"
            v-model="isRetificacao"
            name="radios"
            size="small"
          )
            el-radio.radio(
              :label="false"
              border
            ) Cadastro
            el-radio.radio(
              :label="true"
              border
            ) Retificação
        div.height-upload
          validation-provider(rules="required", v-slot="{ errors }")
            app-label.margin-top(label="Upload do .SiCARF:")
            app-upload-area.margin-bottom(
              id="anexo"
              :target="urlUpload"
              :fileType="validExtensions"
              :onSuccess="onSuccess"
              @download="download"
              :documento="documento"
              v-model="documento"
              @removerDocumento="removerDocumento"
              @onError="onError"
              :maxSize="10000000"
              :errors="errors"
            )
        div.margin-top(v-if="isPa")
          el-row(:gutter="20")
            el-col(:span="8")
              validation-provider(:rules="isRequired()", v-slot="{ errors }")
                app-label(
                  label="Ordem de Serviço: ",
                  :required="isRetificacao ? false : true"
                )
                el-select.input(
                  :class="{'erro' : errors.length}",
                  v-model="ordemServico",
                  filterable
                  placeholder="Selecione a Ordem de Serviço:",
                  :disabled="isRetificacao ? true : false"
                  :required="isRetificacao ? false : true",
                  @change="changeOrdemServico(ordemServico)"
                )
                  el-option(
                    v-for='os in ordensServicos',
                    :key='os.id',
                    :label='os.numero',
                    :value='os.id'
                  )
                span.help.erro {{ errors[0] }}
            el-col(:span="8")
              validation-provider(:rules="isRequired()", v-slot="{ errors }")
                app-label(
                  label="Geomensor Responsável:",
                  :required="isRetificacao ? false : true"
                )
                el-select.input(
                  :class="{'erro' : errors.length}",
                  v-model="geomensorResponsavel",
                  filterable
                  :required="isRetificacao ? false : true",
                  :disabled="isDisabledResponsavel"
                  placeholder="Selecione o geomensor responsável:",
                )
                  el-option(
                    v-for='u in usuarios',
                    :key='u.id',
                    :label='u.nome',
                    :value='u.id'
                  )
                span.help.erro {{ errors[0] }}
            el-col(:span="8")
              validation-provider(:rules="isRequired()", v-slot="{ errors }")
                app-label(
                  label="Vistoriador Responsável:",
                  :required="isRetificacao ? false : true"
                )
                el-select.input(
                  :class="{'erro' : errors.length}",
                  v-model="vistoriadorResponsavel",
                  filterable
                  :required="isRetificacao ? false : true",
                  placeholder="Selecione o vistoriador responsável:",
                  :disabled="isDisabledResponsavel"
                )
                  el-option(
                    v-for='u in usuarios',
                    :key='u.id',
                    :label='u.nome',
                    :value='u.id'
                  )
                span.help.erro {{ errors[0] }}
            el-col(:span="8")
              validation-provider(:rules="isRequired()", v-slot="{ errors }")
                app-label(
                  label="Analista GCG/CGIR:",
                  :required="isRetificacao ? false : true",
                )
                el-select.input(
                  :class="{'erro' : errors.length}",
                  v-model="analistaGcgCgir",
                  placeholder="Selecione o analista responsável:",
                  :required="isRetificacao ? false : true",
                  :disabled="isDisabledResponsavel"
                  clearable
                )
                  el-option(
                    v-for='u in analistasGcgCgir',
                    :key='u.id',
                    :label='u.pessoa.pessoaFisica.nome',
                    :value='u.id'
                  )
                span.help.erro {{ errors[0] }}
      div.buttons
        el-button(type="success" @click="enviar")
          | Enviar cadastro&nbsp;
          i.el-icon-check

</template>
<script>
import AppDivider from '@/components/AppDivider'
import AppLabel from '@/components/AppLabel'
import AppUploadArea from '@/components/AppUploadArea'
import FileHelper from '@/utils/fileHelper'
import AppNotificacao from '@/components/mixins/AppNotificacao'
import axios from '@/utils/api'
import { mapActions, mapState } from 'vuex'

export default {
  components: {
    AppDivider,
    AppUploadArea,
    AppLabel
  },

  mixins: [
    AppNotificacao
  ],

  data () {
    return {
      urlUpload: this.$rotas.PUBLICO.UPLOAD,
      validExtensions: ['sicarf'],
      documento: null,
      ordemServico: null,
      geomensorResponsavel: null,
      vistoriadorResponsavel: null,
      ordensServicos: [],
      analistasGcgCgir: [],
      usuarios: [],
      OSGestaoCadastro: null,
      isRetificacao: false,
      analistaGcgCgir: null,
      isPa: process.env.ESTADO === 'pa'
    }
  },

  async created () {
    if (this.isPa) {
      this.OSGestaoCadastro = await axios({
        method: 'GET',
        url: 'ordemServico/findOSGestaoCadastro'
      })
      this.ordensServicos = this.OSGestaoCadastro.responsaveisOS
      this.analistasGcgCgir = this.OSGestaoCadastro.analistasGcgCgir
    }
  },

  computed: {
    ...mapState({
      ORGAO: state => state.userInterface.dadosEstado.ORGAO
    }),
    isDisabledResponsavel () {
      return this.ordemServico === null || this.isRetificacao
    }
  },

  methods: {
    ...mapActions({
      downloadDocumentos: 'documentoArrecadacao/download',
      gerarComprovanteAction: 'upload/gerarComprovante'

    }),
    onSuccess (id, resumableFile, fileKey) {
      this.documento = {
        id: this.documento ? this.documento.id : null,
        fileKey: fileKey,
        nomeOriginal: resumableFile.fileName,
        tamanho: resumableFile.size,
        removed: false
      }
    },
    async download (id) {
      const documento = this.documento
      const arrayBuffer = await this.downloadDocumentos({ fileKey: documento.fileKey, id: documento.id })
      FileHelper.saveFile(arrayBuffer, documento.nomeOriginal)
    },
    removerDocumento () {
      this.documento = null
    },
    changeOrdemServico (idOrdemServico) {
      this.usuarios = this.ordensServicos.find(ordemServico => ordemServico.id === idOrdemServico).responsaveis
      this.geomensorResponsavel = null
      this.vistoriadorResponsavel = null
    },

    async enviar () {
      const valido = await this.$refs.validation.validate()

      if (!valido) {
        this.showNotificacao(this.$messages.TIPO_WARNING, this.$messages.TITULO_WARNING, this.$messages.ERRO_VALIDACAO_FINALIZAR_CADASTRO)
        return
      }
      const form = {
        key: this.documento.fileKey,
        responsaveis: [
          {
            responsavel: {
              id: this.geomensorResponsavel
            },
            funcao: 'GEOMENSOR'
          },
          {
            responsavel: {
              id: this.vistoriadorResponsavel
            },
            funcao: 'VISTORIADOR'
          }
        ],
        ordemServico: {
          id: this.ordemServico
        },
        isRetificacao: this.isRetificacao,

        idAnalistaGcgCgir: this.analistaGcgCgir
      }

      await axios({
        method: 'POST',
        url: 'uploadcadastro/create',
        data: form
      })
        .then((res) => {
          this.showNotificacao(this.$messages.TIPO_SUCCESS, this.$messages.TITULO_SUCCESS, this.$messages.SUCESSO_CADASTRO_RECEPTOR_INTERNO)
          this.documento = null
          this.success(res)
        })
    },

    async success (protocolo) {
      const msgConfirm = protocolo === 'PROCESSAMENTO' ? `Atenção: Seu processo passará pela análise automatizada de jurisdição/monitoramento ambiental. Dentro de alguns minutos, você receberá um e-mail com o retorno das análises.`
        : `Após o envio, será gerado um Comprovante com um número de protocolo. Guarde este documento com segurança em seu
        computador ou realize a impressão.
        <p>O protocolo poderá ser solicitado posteriormente
        para acompanhamento do processo junto ao ${this.ORGAO} não sendo possível emitir segunda via do mesmo.<p>`

      await this.$alert(msgConfirm, 'Gerar comprovante', {
        confirmButtonText: 'Continuar',
        dangerouslyUseHTMLString: true,
        customClass: 'confirm-finalizar',
        showClose: false
      })
      this.showDownloadComprovante = this.file !== null
      if (protocolo === 'PROCESSAMENTO') {
        return
      }
      this.gerarComprovante(protocolo)
    },

    gerarComprovante (protocolo) {
      try {
        this.gerarComprovanteAction(protocolo)
      } catch (error) {
        this.showNotificacao(
          'error',
          'Erro',
          'Ocorreu um problema ao gerar o comprovante. Acesse a central do interessado para gerar uma segunda via.'
        )
      }
    },

    onError () {
      this.documento = null
    },
    isRequired () {
      return !this.isRetificacao ? 'required' : ''
    },
    setGeomensorVistoriador () {
      this.ordemServico = null
      this.vistoriadorResponsavel = null
      this.geomensorResponsavel = null
    }

  }
}
</script>
<style scoped>

.container {
  height: 85vh;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.margin-top {
  margin-top: 30px;
}

.buttons {
  display: flex;
  justify-content: flex-end;
}

.height-upload {
  height: 200px;
}

.margin-bottom {
  margin-bottom: 30px;
}

.input {
  width: 100%;
}

.radio-buttons {
  display: flex;
  justify-content: center;
  margin-top: 30px;
}

.label {
  margin-top: 20px;
}

.el-col {
  height: 120px;
}
</style>



// WEBPACK FOOTER //
// src/screens/receptor/Upload.vue